export const ARKOSE_GATE_VERIFY_OR_BYPASS_INTERACTION_IDS = {
  CONTINUE: 'arkose-gate-continue',
} as const;
